import styled from "styled-components";

export const MapSectionRoot = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
`;

export const MapSummary = styled.p`
  margin: 0;
  font-size: 0.88rem;
  color: var(--text-secondary);
  line-height: 1.45;
`;

export const LayerToggles = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem 1.1rem;
`;

export const LayerToggle = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.86rem;
  color: var(--text-primary);
  cursor: pointer;
  user-select: none;

  input {
    accent-color: var(--accent);
    cursor: pointer;
  }
`;

export const LayerDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ $color }) => $color || "var(--accent)"};
  flex-shrink: 0;
`;

export const LayerCount = styled.span`
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-secondary);
  background: var(--surface-secondary);
  border: 1px solid var(--border-default);
  border-radius: 999px;
  padding: 0.1rem 0.45rem;
`;

export const MapFrame = styled.div`
  position: relative;
  width: 100%;
  height: 480px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--border-default);
  background: var(--surface-secondary);
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    height: min(420px, 55vh);
  }

  .leaflet-container {
    height: 100%;
    width: 100%;
    font-family: inherit;
  }
`;

export const MapEmptyBanner = styled.div`
  position: absolute;
  z-index: 500;
  top: 12px;
  left: 12px;
  right: 12px;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  background: color-mix(in srgb, var(--surface-1) 92%, transparent);
  border: 1px solid var(--border-default);
  color: var(--text-secondary);
  font-size: 0.88rem;
  pointer-events: none;
`;

export const MapLoading = styled.div`
  height: 480px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 1px solid var(--border-default);
  background: var(--surface-secondary);
  color: var(--text-secondary);
  font-size: 0.9rem;

  @media screen and (max-width: 768px) {
    height: min(420px, 55vh);
  }
`;

export const CoordsAccordion = styled.details`
  width: 100%;
  border: 1px solid var(--border-default);
  border-radius: 12px;
  background: var(--surface-secondary);
  overflow: hidden;

  summary {
    cursor: pointer;
    padding: 0.85rem 1rem;
    font-size: 0.88rem;
    font-weight: 600;
    color: var(--text-heading);
    list-style: none;

    &::-webkit-details-marker {
      display: none;
    }
  }

  summary::before {
    content: "▸ ";
    color: var(--accent);
  }

  &[open] summary::before {
    content: "▾ ";
  }
`;

export const CoordsTableWrap = styled.div`
  padding: 0 0 0.5rem;
  overflow-x: auto;
`;

export const CoordsTableTitle = styled.div`
  padding: 0.35rem 1rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--accent);
`;

export const CoordsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;

  th,
  td {
    text-align: left;
    padding: 0.55rem 1rem;
    border-top: 1px solid var(--border-default);
    color: var(--text-primary);
    vertical-align: top;
  }

  th {
    background: var(--table-header-bg);
    font-size: var(--table-header-font-size);
    text-transform: uppercase;
    letter-spacing: var(--table-header-letter-spacing);
    color: var(--table-header-color);
    font-weight: var(--table-header-font-weight);
  }

  tbody tr:nth-child(even) {
    background: color-mix(in srgb, var(--surface-1) 55%, transparent);
  }
`;

/** Botão do código (alerta / solicitação) — visual alinhado a "Alerta Criado" */
export const MapCodeButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  padding: 0.4rem 0.85rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  font-family: inherit;
  letter-spacing: 0.02em;
  cursor: pointer;
  color: var(--text-on-accent, #fff);
  background: var(--accent, #6b8f71);
  border: 1px solid var(--accent, #6b8f71);
  box-shadow: 0 1px 2px color-mix(in srgb, var(--accent) 35%, transparent);
  text-decoration: none;
  white-space: nowrap;
  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease,
    opacity 0.15s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    filter: brightness(1.05);
    box-shadow: 0 4px 12px color-mix(in srgb, var(--accent) 40%, transparent);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.65;
    cursor: wait;
  }
`;

export const PopupLink = styled.a`
  display: inline-block;
  margin-top: 0.35rem;
  color: var(--info);
  font-size: 0.85rem;
`;
